/* myBuddy v4 · comportamenti condivisi */
(function(){
  function onReady(fn){if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',fn);else fn()}

  /* schede (I più amati) */
  function tabs(root){
    root.querySelectorAll('[data-m2-tabs]').forEach(function(box){
      var sec=box.closest('[data-m2-tabwrap]')||document;
      var bs=box.querySelectorAll('[data-pane]');
      bs.forEach(function(b){b.addEventListener('click',function(){
        bs.forEach(function(x){x.classList.toggle('is-on',x===b)});
        sec.querySelectorAll('.m2-pane').forEach(function(p){p.hidden=p.dataset.pane!==b.dataset.pane});
      })});
    });
  }

  /* video: si caricano solo quando visibili; con data-s/data-e ripetono solo quel pezzo */
  function videos(root){
    root.querySelectorAll('video[data-m2-src]').forEach(function(v){
      if(v.dataset.m2init)return;v.dataset.m2init='1';
      var a=parseFloat((v.dataset.s||'0').replace(',','.'))||0,b=parseFloat((v.dataset.e||'0').replace(',','.'))||0,seg=b>a;
      var src=(innerWidth<750&&v.dataset.m2Sd)?v.dataset.m2Sd:v.dataset.m2Src;
      if(seg){
        var run=false,chk=function(){if(v.currentTime>=b||v.currentTime<a-0.05)v.currentTime=a;if(v.paused){run=false;return}requestAnimationFrame(chk)};
        v.addEventListener('playing',function(){if(!run){run=true;chk()}});
        v.addEventListener('timeupdate',function(){if(v.currentTime>=b)v.currentTime=a});
      }
      var go=function(){
        if(!v.dataset.on){v.dataset.on='1';v.src=src+(seg?'#t='+a:'');if(seg)v.addEventListener('loadedmetadata',function(){v.currentTime=a},{once:true})}
        var p=v.play();if(p&&p.catch)p.catch(function(){});
      };
      if('IntersectionObserver' in window){
        new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting)go();else if(v.dataset.on)v.pause()})},{rootMargin:'150px'}).observe(v);
      }else go();
    });
  }

  /* filtri per categoria nelle collezioni */
  function chips(root){
    var box=root.querySelector('[data-chips]'),grid=root.querySelector('[data-grid]');if(!box||!grid||box.dataset.m2init)return;box.dataset.m2init='1';
    var cards=[].slice.call(grid.querySelectorAll('.m2-card')),promo=grid.querySelector('[data-promo]'),cnt=root.querySelector('[data-count]');
    var chipsEl=[].slice.call(box.querySelectorAll('.m2-chip')),used={};
    cards.forEach(function(c){used[c.dataset.cat]=(used[c.dataset.cat]||0)+1});
    if(Object.keys(used).length<2){box.style.display='none';return}
    chipsEl.forEach(function(ch){if(ch.dataset.c!=='all')ch.hidden=!used[ch.dataset.c]});
    function set(c){
      chipsEl.forEach(function(x){x.classList.toggle('is-on',x.dataset.c===c)});
      var n=0;cards.forEach(function(card){var ok=c==='all'||card.dataset.cat===c;card.classList.toggle('is-hid',!ok);if(ok)n++});
      if(promo)promo.style.display=c==='all'?'':'none';
      if(cnt)cnt.textContent=n+' prodotti';
    }
    chipsEl.forEach(function(ch){ch.addEventListener('click',function(){set(ch.dataset.c);try{history.replaceState(null,'',ch.dataset.c==='all'?location.pathname+location.search:'#'+ch.dataset.c)}catch(e){}})});
    var h=location.hash.replace('#','');if(h&&used[h])set(h);
  }

  /* titolo prodotto: al massimo 2 righe su mobile */
  function fitTitle(){
    document.querySelectorAll('[data-m2-fit]').forEach(function(h){
      if(innerWidth>900)return;var fs=parseFloat(getComputedStyle(h).fontSize),n=0;
      while(fs>18&&n<12&&h.getBoundingClientRect().height>(parseFloat(getComputedStyle(h).lineHeight)||fs*1.05)*2.3){fs-=1;n++;h.style.setProperty('font-size',fs+'px','important')}
    });
  }


  /* guida taglie in popup */
  function sizeGuide(){
    var dlg=document.querySelector('[data-m2-sg]');if(!dlg||dlg.dataset.m2init)return;dlg.dataset.m2init='1';
    function open(e){if(!dlg.showModal)return;e.preventDefault();dlg.showModal();document.documentElement.style.overflow='hidden'}
    function close(){dlg.close()}
    dlg.addEventListener('close',function(){document.documentElement.style.overflow=''});
    document.addEventListener('click',function(e){var a=e.target.closest&&e.target.closest('a[href*="guida-alle-taglie"],[data-m2-sg-open]');if(a&&!a.closest('.m2-hd,.m2-ft,.m2-drawer'))open(e)});
    dlg.addEventListener('click',function(e){if(e.target===dlg||e.target.closest('[data-m2-sg-close]'))close()});
  }

  function init(root){tabs(root);videos(root);chips(root);sizeGuide()}
  onReady(function(){init(document);fitTitle();if(document.fonts&&document.fonts.ready)document.fonts.ready.then(fitTitle)});
  /* editor del tema: reinizializza le sezioni ricaricate */
  document.addEventListener('shopify:section:load',function(e){init(e.target);fitTitle()});
  window.m2init=init;
})();
